<template>
  <div class="flex min-h-screen flex-col">
    <div class="mx-auto max-w-screen-lg px-6 py-12 pb-6">
      <a
        :href="PUBLIC_ROUTES.ROOT"
        class="flex items-center text-white transition duration-300 hover:opacity-90"
      >
        <img
          class="h-8 md:h-10"
          src="/athleticnext_light.svg"
          alt="AthleticNext dark logo on light background"
        />
      </a>
    </div>
    <div class="z-10 mx-auto w-full max-w-xl px-2 pb-12">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PUBLIC_ROUTES } from 'src/core/AppRoutes';
</script>

<style scoped>
.radial-animation {
  animation-delay: 1.75s;
  animation: animate 15s ease-in-out infinite;
  background: radial-gradient(50% 50% at 50% 50%, #187879, transparent 100%);
}

@keyframes animate {
  0% {
    right: 0%;
  }

  25% {
    top: 40%;
  }

  50% {
    right: 5%;
  }

  75% {
    top: 50%;
  }

  100% {
    right: 0%;
  }
}
</style>
